import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import * as legend from '../../config/legend'
import { CommonService } from '../../service/common.service';
import { EChartOption, EChartTitleOption } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';
import { ECharts } from 'echarts';
import { DoubleRingPieComponent } from './double-ring-pie.component';
import { isNil } from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class DoubleRingPieService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }

  // 顶部legend变化
  topLegendChange(legendData: any[], optionInit: ECharts) {
    legendData.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        })
      }
    })
  }

  changeChartTitleDark(component, darkMode) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  setLegendPosition(legendOption, legendPosition: string) {
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        break;
      case "bottom":
        legendOption.show = true;
        break;
      case "none":
        legendOption.show = false;
        break;
      default:
        legendOption.show = true;
        // gridOption.bottom = legend.bottomLegendHeight;
        break;
    }
  }

  // 改变颜色
  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    })
  }

  buildSeries(chartData: any, seriesList: EChartOption.SeriesPie[], outsidePieSeries: EChartOption.SeriesPie, insidePieSeries: EChartOption.SeriesPie) {
    seriesList.length = 0;

    if (chartData.hasOwnProperty('outsideData')) {
      outsidePieSeries.data = chartData.outsideData;
    }
    if (chartData.hasOwnProperty('insideData')) {
      insidePieSeries.data = chartData.insideData;
    }

    seriesList.push(insidePieSeries, outsidePieSeries);
  }

  setSmallModePadding(component: DoubleRingPieComponent) {
    component.cardPadding = '0rem';
  }

  getOutSidePieSeries() {
    let series = this.chartOptionService.getDefaultPieSeries();
    series.radius = ['65%', '75%'];
    series.label.formatter = '{b}: {c}'

    return series;
  }

  getInsidePieSeries() {
    let series = this.chartOptionService.getDefaultPieSeries();
    series.radius = '55%';
    series.label.formatter = '{b}: {d}%'
    return series;
  }

  legendDarkMode(legendOption) {
    if (isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }

  setLabelType(type, pieChartSeries: EChartOption.SeriesPie) {
    if (type == 'value') {
      pieChartSeries.label.formatter = '{b}: {c}';
    } else if (type == 'percent') {
      pieChartSeries.label.formatter = '{b}: {d}%';
    }
  }

  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    })
  }

  seriesDarkMode(pieChartSeries: EChartOption.SeriesPie) {
    if (_.isNil(pieChartSeries['label'])) {
      pieChartSeries['label'] = {};
    }
    pieChartSeries['label']['color'] = color.darkModeTextColor;
  }

  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;

  }

  setInsidePieLabelLength(length: number, insidePieSeries: EChartOption.SeriesPie) {
    insidePieSeries.labelLine.length = length;
  }

  setInsidePieLabelLength2(length2: number, insidePieSeries: EChartOption.SeriesPie) {
    insidePieSeries.labelLine.length2 = length2;
  }

  setOutsidePieLabelLength(length: number, outsidePieSeries: EChartOption.SeriesPie) {
    outsidePieSeries.labelLine.length = length;
  }

  setOutsidePieLabelLength2(length2: number, outsidePieSeries: EChartOption.SeriesPie) {
    outsidePieSeries.labelLine.length2 = length2
  }

  setInsidePieRadius(radius, insidePieSeries: EChartOption.SeriesPie) {
    insidePieSeries.radius = radius;
  }

  setOutsidePieRadius(radius, outsidePieSeries: EChartOption.SeriesPie) {
    outsidePieSeries.radius = radius;
  }

  setChartTitle(chartTitle, echartTitle) {
    echartTitle.text = chartTitle;
    echartTitle.show = true;

  }

  chartTitleDarkMode(echartTitleOption) {
    echartTitleOption.textStyle.color = color.darkTextColor;
  }

  getDefaultChartTitle() {
    let style = this.commonService.changeFontSize();
    let echartTitle = this.chartOptionService.getDefaultChartTitle();
    echartTitle.textStyle.fontWeight = 500;
    echartTitle.textStyle.fontSize = style.fontSize + 2;
    return echartTitle;
  }

  setPieCenter(center, outsidePieSeries: EChartOption.SeriesPie, insidePieSeries: EChartOption.SeriesPie) {
    insidePieSeries.center = center;
    outsidePieSeries.center = center;
  }

}
